import React, { useState, useEffect } from "react";
import {
  Input,
  Table,
  Card,
  CardBody,
  CardHeader,
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import PageLayout from "../PageLayout";
import {
  getReviewerRequestsApi,
  updateJournalStatusApi,
} from "src/network/api";
import { toast } from "react-toastify";
import { useAppSelector } from "src/state/store/store";
import { getApprovalStatusPill } from "src/utils/appUtils";

const ReviewerRequestsList = () => {
  const [journals, setJournals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const user = useAppSelector((state) => state.auth.user);

  const fetchJournals = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await getReviewerRequestsApi();
      if (response.data && response.data.status === 200) {
        setJournals(response.data.data);
      } else {
        setError(response.data.message || "Failed to fetch data.");
        setJournals([]);
      }
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.error("Error fetching data:", err);
      setJournals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJournals();
  }, []);

  const handleStatusUpdate = async (req_id, approval_status) => {
    console.log("Journal ID:", req_id);

    const confirmAction = window.confirm(
      `Are you sure you want to ${approval_status.toLowerCase()} this journal?`
    );
    if (!confirmAction) return;

    try {
      const payload = { approval_status };
      const response = await updateJournalStatusApi(req_id, payload);
      if (response.status == 200 && response.data.status === 200) {
        toast.success(
          response.data?.message || "Request Status updated successfully"
        );
        fetchJournals();
      } else {
        toast.error(
          response.data.message || "Failed to update journal status."
        );
      }
    } catch (e) {
      console.error(e);
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  return (
    <PageLayout>
      <Container fluid className="mt-4 mb-4">
        <Row>
          <Col lg="12" className="mx-auto">
            <Card className="shadow-lg mt-4">
              <CardHeader className="bg-primary text-white text-center">
                <h4 className="text-white font-weight-bold">
                  Journal Join Requests
                </h4>
              </CardHeader>

              <Table bordered hover responsive className="table-sm mb-5">
                <thead className="thead-light">
                  <tr>
                    <th>Journal Id</th>
                    <th>Journal Name</th>

                    <th>E-ISSN No</th>
                    <th>Reviewer Name</th>
                    <th>Contact</th>
                    <th>Designation</th>
                    <th>University</th>
                    <th>Profile Image</th>
                    <th>Approval Status</th>
                    <th>Send By</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={14} className="text-center">
                        No data available
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan={14} className="text-center text-danger">
                        {error}
                      </td>
                    </tr>
                  ) : journals.length > 0 ? (
                    journals.map((journal, index) => (
                      <tr key={index}>
                        <td>{journal.journal_id || "N/A"}</td>
                        <td>{journal.journal_name || "N/A"}</td>
                        <td>{journal.eissn_no || "N/A"}</td>
                        <td>{journal.reviewer_name || "N/A"}</td>
                        <td>{journal.reviewer_contact || "N/A"}</td>
                        <td>{journal.designation || "N/A"}</td>
                        <td>{journal.university_name || "N/A"}</td>
                        <td>
                          {journal.profile_image ? (
                            <img
                              src={journal.profile_image}
                              alt="Profile"
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            "N/A"
                          )}
                        </td>

                        <td>
                          {getApprovalStatusPill(journal.approval_status)}
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {journal.sender != user.type ? journal.sender : "You"}
                        </td>
                        <td>{journal.created_at || "N/A"}</td>
                        <td>
                          <div className="d-flex justify-content-around">
                            {journal.approval_status == "pending" &&
                              user.type != journal.sender && (
                                <>
                                  <Button
                                    color="success"
                                    size="sm"
                                    onClick={() =>
                                      handleStatusUpdate(
                                        journal.req_id,
                                        "approved"
                                      )
                                    }
                                  >
                                    Approve
                                  </Button>
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() =>
                                      handleStatusUpdate(
                                        journal.req_id,
                                        "rejected"
                                      )
                                    }
                                  >
                                    Reject
                                  </Button>
                                </>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={12} className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  );
};

export default ReviewerRequestsList;
